import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../../assets/css/ImageModal.css"; // You can create and style this CSS file as needed
import Modal from "react-bootstrap/Modal";

const ImageModal = ({ images, onClose, show, selectedImage, setSelectedImage }) => {

  const isVideo = (url) => {
    return url.match(/\.(mp4|webm|ogg)$/i);
  };

  const renderThumbs = () => {
    return images.map((media, index) => (
      <div
        key={index}
        onClick={() => setSelectedImage(index)}
        renderThumbs={renderThumbs}
        className={`media-container ${
          index === selectedImage ? "selected" : ""
        }`}
      >
        {isVideo(media?.url) ? (
          <video className="thumbnail-video" muted>
            <source src={media?.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={media?.url}
            alt={`Thumbnail ${index}`}
            className="thumbnail-image"
          />
        )}
      </div>
    ));
  };

  return (
    <Modal show={show} onHide={onClose} centered className="imagemodal">
       <div className="close" style={{marginRight:'25%',opacity:'0.6'}}>
      <span style={{marginBottom:'5px'}} onClick={onClose}>
        x
      </span>
      
    </div>
      <Carousel
        renderThumbs={renderThumbs}
        selectedItem={selectedImage}
        onChange={(index) => setSelectedImage(index)?.url}
      >
        {images.map((media, index) => (
          <div key={index} className="media-container">
            {isVideo(media?.url) ? (
              <video controls className="rounded w-100" height={300}>
                <source src={media?.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={media?.url}
                alt={`Slide ${index}`}
                className="rounded"
              />
            )}{" "}
          </div>
        ))}
      </Carousel>
    </Modal>
  );
};

export default ImageModal;
